// Thin wrapper over window.Telegram.WebApp, typed for the parts we use.

interface WebApp {
  initData: string;
  initDataUnsafe: { user?: { id: number; first_name: string; username?: string }; start_param?: string };
  version: string;
  platform: string;
  ready(): void;
  expand(): void;
  requestFullscreen?(): void;
  disableVerticalSwipes?(): void;
  /** Keeps the app in the way the phone is held now (Telegram 8.0). */
  lockOrientation?(): void;
  unlockOrientation?(): void;
  setHeaderColor?(color: string): void;
  setBackgroundColor?(color: string): void;
  isVersionAtLeast(version: string): boolean;
  HapticFeedback?: {
    impactOccurred(style: "light" | "medium" | "heavy" | "rigid" | "soft"): void;
    notificationOccurred(type: "error" | "success" | "warning"): void;
  };
  BackButton?: { show(): void; hide(): void; onClick(fn: () => void): void; offClick(fn: () => void): void };
  openTelegramLink?(url: string): void;
  /** Telegram's own payment sheet for an invoice link (Stars), with how it ended. */
  openInvoice?(url: string, callback?: (status: "paid" | "cancelled" | "failed" | "pending") => void): void;
  /** Opens a web page in the phone's browser, outside Telegram. */
  openLink?(url: string): void;
  onEvent?(event: string, fn: () => void): void;
  offEvent?(event: string, fn: () => void): void;
  requestWriteAccess?(callback?: (granted: boolean) => void): void;
  /** Opens Telegram's chat picker with a message the bot prepared (Telegram 8.0). */
  shareMessage?(preparedId: string, callback?: (sent: boolean) => void): void;
  /** Opens the story editor with this image (Telegram 7.8). */
  shareToStory?(mediaUrl: string, params?: { text?: string; widget_link?: { url: string; name?: string } }): void;
  /** Asks to save a file to the phone (Telegram 8.0). */
  downloadFile?(params: { url: string; file_name: string }, callback?: (accepted: boolean) => void): void;
}

declare global {
  interface Window {
    Telegram?: { WebApp: WebApp };
  }
}

export const tg: WebApp | undefined = window.Telegram?.WebApp?.initData ? window.Telegram.WebApp : undefined;

/** Fullscreen with Telegram's own buttons on top, matching the approved design. */
export function initTelegram(): void {
  if (!tg) return;
  tg.ready();
  tg.expand();
  if (tg.isVersionAtLeast("8.0")) tg.requestFullscreen?.();
  if (tg.isVersionAtLeast("7.7")) tg.disableVerticalSwipes?.();
  tg.setHeaderColor?.("#0B0E14");
  tg.setBackgroundColor?.("#0B0E14");
  keepUpright();
  addEventListener("resize", keepUpright);
}

let mayRotate = false;
let locked = false;
/**
 * Every screen is drawn upright, so the app stays upright: it locks as soon as the phone is held that way.
 * Only the full screen chart lets the phone turn sideways.
 */
function keepUpright(): void {
  if (!tg?.isVersionAtLeast("8.0") || mayRotate || locked || innerHeight < innerWidth) return;
  tg.lockOrientation?.();
  locked = true;
}
export function allowRotation(on: boolean): void {
  if (!tg?.isVersionAtLeast("8.0")) return;
  mayRotate = on;
  if (on) {
    tg.unlockOrientation?.();
    locked = false;
  } else keepUpright();
}
